export default "__VITE_ASSET__CJ33sWSr__"